import TabbedSelector from '@/components/TabbedSelector'
import { workActivitiesPageSubRoutes } from '@/routes/workactivities/WorkActivitiesPage.route'

export default function WorkActivitiesPage() {
  return (
    <>
      <h2 className={'content-block'}>Ore</h2>
      <div className={'content-block'}>
        <TabbedSelector tabs={workActivitiesPageSubRoutes} />
      </div>
    </>
  )
}
